/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { List, ListItem, Typography } from "@mui/material";

import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("meters.title")}
      </Typography>
      <hr />

      {/* --- Setup / Type --- */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("meters.setup.title")}
      </Typography>

      <Typography variant="h4" mt={2} ml={4}>
        {t("meters.setup.type_title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("meters.setup.type_intro")}
        </Box>
      </Typography>

      <Box ml={6}>
        <List component="ul">
          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("meters.setup.type_items.cpe_title")}
              </Typography>{" "}
              {t("meters.setup.type_items.cpe_desc")}
            </Typography>
          </ListItem>

          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("meters.setup.type_items.internal_title")}
              </Typography>{" "}
              {t("meters.setup.type_items.internal_desc")}
            </Typography>
          </ListItem>
        </List>
      </Box>

      {/* --- Installation type --- */}
      <Typography variant="h4" mt={2} ml={4}>
        {t("meters.setup.installation_title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("meters.setup.installation_intro")}
        </Box>
      </Typography>

      <Box ml={6}>
        <List component="ul">
          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("meters.setup.installation_items.iu_title")}
              </Typography>{" "}
              {t("meters.setup.installation_items.iu_desc")}
            </Typography>
          </ListItem>
          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("meters.setup.installation_items.ic_title")}
              </Typography>{" "}
              {t("meters.setup.installation_items.ic_desc")}
            </Typography>
          </ListItem>
          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("meters.setup.installation_items.scpu_title")}
              </Typography>{" "}
              {t("meters.setup.installation_items.scpu_desc")}
            </Typography>
          </ListItem>
          <ListItem component="li" divider>
            <Typography variant="text" fontSize="1rem" mt={2}>
              <Typography component="span" variant="text" fontWeight={700} fontSize="1rem">
                {t("meters.setup.installation_items.storage_title")}
              </Typography>{" "}
              {t("meters.setup.installation_items.storage_desc")}
            </Typography>
          </ListItem>
        </List>
      </Box>

      {/* --- Columns: Resource --- */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("meters.resource_column.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("meters.resource_column.body")}
        </Box>
      </Typography>

      {/* --- Columns: CPE --- */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("meters.cpe_column.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("meters.cpe_column.body")}
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
